import { createContext, ReactNode, useMemo } from 'react';

type Props = {
  children: ReactNode;
  missionToken: string;
};

export type MissionContext = {
  missionToken: string;
};

export const missionContext = createContext<MissionContext>(undefined as unknown as MissionContext);

export const MissionProvider = ({ children, missionToken }: Props) => {
  const value = useMemo<MissionContext>(() => ({ missionToken }), [missionToken]);

  return <missionContext.Provider value={value}>{children}</missionContext.Provider>;
};
